/**
 * 이용약관 / 개인정보 처리방침 정적 콘텐츠
 *
 * 원본: 구글독스 (2026-08-20 스냅샷)
 * - 이용약관: 1sBHvp_3heAVTKJRk5CZDCdgp6GxKl96q8lqzLPBl11M
 * - 개인정보 처리방침: 1qx1oRpQU3Zh9_Tm9Jz7-AIb6tNsqQvCJQMhOn637R7U
 */

export type LegalDocType = 'terms' | 'privacy';

export interface LegalSection {
  /** 조 제목 (예: "제1조 (목적)") */
  title?: string;
  /** 본문 문단 */
  paragraphs?: string[];
  /** 번호/불릿 목록 */
  items?: string[];
}

export interface LegalDoc {
  title: string;
  /** 문서 상단 소개 문단 */
  intro?: string;
  sections: LegalSection[];
}

export const LEGAL_DOCS: Record<LegalDocType, LegalDoc> = {
  terms: {
    title: '키키즈(kikiz) 이용약관',
    sections: [
      {
        title: '제1조 (목적)',
        paragraphs: [
          '본 약관은 주식회사 굳갱랩스(이하 "회사")가 제공하는 키키즈(kikiz) 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.',
        ],
      },
      {
        title: '제2조 (서비스의 성격)',
        items: [
          '본 서비스는 현재 베타(Beta) 버전으로 제공됩니다.',
          '서비스는 상용화 이전 단계로, 불안정할 수 있으며 오류, 중단, 기능 제한 등이 발생할 수 있습니다.',
          '이용자는 서비스가 베타 버전임을 충분히 이해하고 사용하며, 회사는 서비스 안정성, 정확성, 완전성을 보장하지 않습니다.',
        ],
      },
      {
        title: '제3조 (정의)',
        items: [
          '"서비스"란 회사가 제공하는 AI 아바타와 음성·문자를 통한 대화 서비스 전반을 의미합니다.',
          '"이용자"란 본 약관에 동의하고 서비스를 이용하는 자를 의미합니다.',
          '"콘텐츠"란 이용자가 서비스 이용 과정에서 입력하거나 전송하는 음성, 문자, 이미지 등 일체의 데이터를 의미합니다.',
        ],
      },
      {
        title: '제4조 (약관의 효력 및 변경)',
        items: [
          '본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력이 발생합니다.',
          '회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수 있으며, 변경된 약관은 서비스 내 공지사항 등을 통해 사전 고지합니다.',
          '이용자에게 불리한 변경일 경우 최소 30일 전 공지하며, 일반적인 변경은 최소 7일 전 공지합니다.',
        ],
      },
      {
        title: '제5조 (서비스의 제공 및 변경)',
        items: [
          '본 서비스는 무료로 제공됩니다.',
          '서비스 제공 시간, 범위, 기능 등은 회사의 정책과 운영 사정에 따라 조정·변경될 수 있으며, 회사는 사전 동의나 별도 고지 없이 임의로 조절할 수 있습니다.',
          '회사는 연중무휴 제공을 보장하지 않으며, 필요에 따라 서비스 제공을 일시 중단하거나 종료할 수 있습니다.',
          '회사는 서비스 변경 또는 중단 시 가능한 경우 사후에 이용자에게 이를 공지할 수 있습니다.',
        ],
      },
      {
        title: '제6조 (AI 서비스 특성 고지)',
        items: [
          '본 서비스는 인공지능 기술을 활용하여 응답을 생성하므로, 정확하거나 완전한 답변을 보장하지 않습니다.',
          '서비스가 제공하는 정보는 참고용일 뿐, 전문적 조언이나 사실로 의존해서는 안 됩니다.',
          '이용자는 AI의 답변을 기반으로 발생하는 결과에 대한 최종 책임이 본인에게 있음을 이해하고 동의합니다.',
        ],
      },
      {
        title: '제7조 (이용자의 의무)',
        paragraphs: ['이용자는 다음 행위를 해서는 안 됩니다.'],
        items: [
          '타인의 개인정보 또는 정보를 도용하는 행위',
          '서비스 운영을 방해하거나 불법적으로 이용하는 행위',
          '법령, 공공질서 및 미풍양속에 위반되는 행위',
          '회사의 지식재산권 및 제3자의 권리를 침해하는 행위',
        ],
      },
      {
        title: '제8조 (지식재산권)',
        items: [
          '서비스 및 관련 소프트웨어, 디자인, 아바타, 음성 등 일체의 지식재산권은 회사에 귀속됩니다.',
          '이용자는 회사의 사전 승인 없이 이를 무단 복제, 배포, 변형, 전송할 수 없습니다.',
        ],
      },
      {
        title: '제9조 (면책)',
        items: [
          '회사는 서비스가 베타 버전으로 제공됨에 따라 발생하는 오류, 장애, 중단, 데이터 손실 등에 대해 책임을 지지 않습니다.',
          '회사는 서비스 제공 여부, 제공 시간, 기능 조정 등과 관련하여 발생하는 이용자의 불이익에 대해 책임을 지지 않습니다.',
          '회사는 인공지능이 제공하는 정보의 정확성, 신뢰성, 완전성에 대해 보장하지 않으며, 이용자가 이를 근거로 내린 판단이나 행동에 대해 책임을 지지 않습니다.',
        ],
      },
      {
        title: '제10조 (관할법원 및 준거법)',
        items: [
          '본 약관의 해석 및 적용은 대한민국 법률에 따릅니다.',
          '서비스와 관련하여 분쟁이 발생할 경우, 민사소송법상의 관할법원을 제1심 법원으로 합니다.',
        ],
      },
      {
        title: '회사 정보',
        items: [
          '상호: 주식회사 굳갱랩스',
          '대표자: 안두경',
          '이메일: hello@goodganglabs.com',
        ],
      },
    ],
  },
  privacy: {
    title: '키키즈(kikiz) 개인정보 처리방침',
    intro:
      '주식회사 굳갱랩스(이하 "회사")는 「개인정보보호법」 등 관계 법령을 준수하며, 키키즈(kikiz) 서비스 이용자의 개인정보를 소중히 보호합니다. 본 방침은 서비스 이용과 관련하여 개인정보가 어떻게 수집·이용·보관·파기되는지 안내합니다.',
    sections: [
      {
        title: '제1조 (수집하는 개인정보 항목)',
        paragraphs: [
          '회사는 회원가입 절차 없이 서비스를 제공합니다. 다만 서비스 이용 과정에서 다음과 같은 정보가 수집될 수 있습니다.',
        ],
        items: [
          '음성 입력 데이터',
          '문자(텍스트) 입력 데이터',
          '기기 정보(IP, 브라우저, OS 등)',
          '서비스 이용기록, 접속 로그, 쿠키',
        ],
      },
      {
        title: '제2조 (개인정보 이용 목적)',
        paragraphs: ['수집한 개인정보는 다음 목적에 한해 이용됩니다.'],
        items: [
          'AI 아바타 음성·문자 대화 제공',
          '서비스 품질 개선 및 오류 분석',
          '보안 관리 및 부정 이용 방지',
        ],
      },
      {
        title: '제3조 (개인정보 제3자 제공 및 국외 이전)',
        items: [
          '회사는 원칙적으로 개인정보를 제3자에게 제공하지 않습니다.',
          '다만, 서비스 운영 및 개선을 위해 굳갱랩스 관계사(예: Good Gang Labs Pte. Ltd.) 등 해외 법인에 개인정보를 이전·공유할 수 있습니다.',
          '이전되는 정보: 서비스 이용 과정에서 수집된 데이터(음성·문자 입력, 로그 등)',
          '이전 국가: 싱가포르 및 서버 소재 국가',
          '이용 목적: 서비스 운영 및 품질 개선',
          '보유 기간: 목적 달성 시 또는 이용 종료 시까지',
        ],
      },
      {
        title: '제4조 (개인정보 보유 및 파기)',
        items: [
          '회사는 개인정보 수집 목적 달성 시 지체 없이 파기합니다.',
          '전자적 파일은 복구할 수 없는 방법으로 삭제하며, 출력물은 분쇄 또는 소각합니다.',
          '다만, 법령에 따라 일정 기간 보존이 필요한 경우 해당 기간 동안 보관합니다. (통신비밀보호법: 접속 기록 3개월)',
        ],
      },
      {
        title: '제5조 (이용자의 권리)',
        paragraphs: [
          '이용자는 언제든 자신의 개인정보에 대해 열람·정정·삭제·처리정지를 요청할 수 있습니다.',
        ],
        items: ['요청 방법: 이메일(hello@goodganglabs.com)'],
      },
      {
        title: '제6조 (개인정보 보호책임자)',
        items: [
          '개인정보 보호책임자: 장성훈',
          '이메일: privacy@goodganglabs.com',
        ],
      },
      {
        title: '제7조 (개정 고지)',
        paragraphs: ['회사는 본 방침을 개정할 경우, 서비스 화면에 공지합니다.'],
      },
      {
        title: '회사 정보',
        items: [
          '상호: 주식회사 굳갱랩스',
          '대표자: 안두경',
          '이메일: hello@goodganglabs.com',
        ],
      },
    ],
  },
};
